<template>
  <div>
    <!-- <el-scrollbar class="crm-operate-log pb20"> -->
      <div class="text-align-right mb10">
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </div>
      <div style="overflow:auto;max-height:550px;">
        <el-card class="box-card mb10" v-for="resume in dataList">
          <el-button
            class="pull-right ml5"
            type="primary"
            size="mini"
            @click="handleEdit(resume)"
          >编辑</el-button>
          <el-button
            class="pull-right"
            type="warning"
            plain
            size="mini"
            @click="handleDelete(resume)"
          >删除</el-button>
          <el-form label-width="100px" style="padding-top:30px;">
            <el-row :gutter="20" align="left">
              <el-col :xs="24" :md="12" :lg="12">
                <el-form-item class="mb10" label="公司名称:">{{resume.companyName}}</el-form-item>
              </el-col>
              <el-col :xs="24" :md="12" :lg="12">
                <el-form-item
                  class="mb10"
                  label="任职周期:"
                >{{resume.takeOfficeStartTime}}~{{resume.takeOfficeEndTime}}</el-form-item>
              </el-col>
              <el-col :xs="24" :md="12" :lg="12">
                <el-form-item class="mb10" label="部门:">{{resume.apartment}}</el-form-item>
              </el-col>
              <el-col :xs="24" :md="12" :lg="12">
                <el-form-item class="mb10" label="职务:">{{resume.position}}</el-form-item>
              </el-col>
              <el-col :xs="24" :md="12" :lg="12">
                <el-form-item class="mb10" label="业务决策人:">{{resume.isDecisionMaker == 1? '是': '否'}}</el-form-item>
              </el-col>
              <el-col :xs="24" :md="12" :lg="12">
                <el-form-item class="mb10" label="是否在职:">{{resume.isOnTheJob == 1 ? '是': '否'}}</el-form-item>
              </el-col>
              <el-col :xs="24" :md="12" :lg="24">
                <el-form-item class="mb10" label="履历描述:" style="word-break: break-all;">{{resume.remark}}</el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <p v-if="loading" class="tip">加载中...</p>
        <p v-if="!loading" class="tip">{{dataList.length > 0 ? "没有更多了" : "暂无数据"}}</p>
      </div>
    <!-- </el-scrollbar> -->
    <AddResume ref="AddResumeDialogRef" :contactId="contactId" @success="handleQuery" />
  </div>
</template>

<script>
import { queryResumeList, deleteResume } from "@/api/crm/contact";
import AddResume from "./addResumeDialog";
export default {
  components: {
    AddResume
  },
  props: {
    contactId: {
      type: Number,
      default: null
    }
  },
  name: "resume",
  data() {
    return {
      loading: false,
      noMore: false,
      count: 0,
      dataList: [],
      total: [],
      queryParams: {
        pageNum: 1,
      }
    };
  },
  watch: {
    contactId(val) {
      this.queryParams.contactId = val;
      this.queryParams.pageNum = 1;
      this.dataList = [];
      this.getList();
    }
  },
  mounted() {
    if(this.contactId) {
      this.queryParams.contactId = this.contactId 
      this.getList();
    }
  },
  methods: {
    load() {
      this.count += 2;
    },
    getList() {
      this.loading = true;
      queryResumeList(this.queryParams)
        .then(response => {
          this.dataList = response.rows;
          this.loading = false;
          this.$emit('after-query', response.total)
        })
        .catch(error => {
          this.loading = false;
        });
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList()
      this.$emit('success')
    },
    handleAdd() {
      this.$refs.AddResumeDialogRef.open("add");
    },
    handleEdit(row) {
      this.$refs.AddResumeDialogRef.open("edit", row);
    },
    handleDelete(row) {
      let that = this
      this.$confirm("确认删除该数据？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteResume({
          id: row.id
        })
          .then(response => {
            that.getList();
            that.$emit('success')
            this.msgSuccess("删除成功");
          })
          .catch(error => {
            this.loading = false;
          });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.tip {
  text-align: center;
  color: #909399;
  font-size: 14px;
}
</style>